import React from 'react'

import { Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, node, oneOf, string } from 'prop-types'

const ICON_COLOR_MAP = {
  info: 'dark',
  danger: 'warning',
  redemption: 'attention',
  progress: 'primary',
}

function StatusBanner({ icon, title = null, description, variant = 'attention' }) {
  const iconColor = ICON_COLOR_MAP[variant] || variant

  return (
    <div className={`status-banner status-banner--${variant}`} role="alert">
      <Icon svgComponent={icon} color={iconColor} />
      <div className="status-banner__content">
        {title && (
          <strong className="cgt-text-medium cgt-text-medium--semi-bold">{title}</strong>
        )}
        <p className="cgt-text-medium cgt-mb-0">
          {description}
        </p>
      </div>
    </div>
  )
}

StatusBanner.propTypes = {
  icon: func.isRequired,
  title: string,
  description: node.isRequired,
  variant: oneOf(['attention', 'info', 'danger', 'dark', 'redemption', 'progress']),
}

export default StatusBanner
